import React from 'react';
import { Popup, SquareBorderButton } from '@lyearn-team/frontend-components';

import { getRemainingLessonsInfo } from './getRemainingLessonsInfo';

import {
  Instruction,
  LessonItem,
  LessonGlobalPosition,
  LessonName,
  RemainingText,
  ButtonsContainer,
  popupBodyClassName
} from './styles';

const formRemainingText = lesson => 'Remaining things';

const RemainingLessonsPopup = ({
  lessons,
  hidePopup,
  showPopup,
  onLessonClick,
  onBackToHome,
  backToText
}) => (
  <Popup
    header={{ title: 'Lesson(s) Incomplete' }}
    bodyClassName={popupBodyClassName}
    onCloseClick={hidePopup}
    showPopup={showPopup}
    withPortal={true}
    footerComponent={
      <ButtonsContainer>
        <SquareBorderButton
          type="bordered"
          text={backToText.split(':')[0]}
          onClick={onBackToHome}
        />
        <SquareBorderButton
          style={{ marginLeft: '16px' }}
          type="filled"
          text="Continue Learning"
          onClick={hidePopup}
        />
      </ButtonsContainer>
    }
  >
    <Instruction>You need to complete the following lessons to finish this course -</Instruction>
    {lessons.map(lesson => (
      <LessonItem
        onClick={(e) => {
          hidePopup();
          onLessonClick(lesson.pid, e);
        }}
      >
        <LessonGlobalPosition>{lesson.globalPosition}</LessonGlobalPosition>
        <LessonName>{lesson.name}</LessonName>
        {/* <RemainingText>{formRemainingText(lesson)}</RemainingText> */}
      </LessonItem>
    ))}
  </Popup>
);

RemainingLessonsPopup.defaultProps = {
  lessons: [],
  hidePopup: () => {},
  showPopup: true
};

export { getRemainingLessonsInfo };
export default RemainingLessonsPopup;
